import React, { useEffect, useState } from 'react';
import './BusinessHoursModel.css';
import { Box, Modal } from '@mui/material';
import CloseIcon from '../../../assets/svg/closeIcon';
import axiosVendorInstance from '../../../axiosVendorInstance';
import Loader from '../../../Components/Loader/Loader';

const BusinessHoursModel = ({ onClose, open, id }) => {
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [hours, setHours] = useState([]);
    const [loading, setLoading] = useState(false);

    const daysOrder = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday',
        'Friday', 'Saturday', 'Sunday'
    ];

    const getHours = async () => {
        try {
            setLoading(true);
            const response = await axiosVendorInstance.get(
                `/business-hours/vendor/${id}`
            );
            setLoading(false);

            // Sort days by known order
            const sorted = daysOrder.map(day => {
                return response?.data?.business_hours?.find(d => d.day === day) || {
                    day,
                    is_open: false,
                    intervals: []
                };
            });

            setHours(sorted);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching business hours:', error);
        }
    };

    useEffect(() => {
        getHours();
        setTimeout(() => setAnimateModal(true), 100);
    }, []);

    const formatTime = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string') return '--:--';
        const [hour, minute] = timeStr.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
    };

    const renderIntervals = (intervals) => {
        return intervals
            .map(interval =>
                `${formatTime(interval.open_time)} – ${formatTime(interval.close_time)}`
            )
            .join(', ');
    };

    return (
        <>
            {loading && <Loader />}
            <Modal
                open={open}
                onClose={() => {
                    setClosing(true);
                    onClose();
                }}
                style={{
                    backdropFilter: 'blur(10px)',
                    backgroundColor: '#2C3142B2 !important',
                }}
            >
                <Box
                    className={`business-hours-main-container ${animateModal ? 'animate' : ''} ${closing ? 'close' : ''}`}
                >
                    <div className='popup-container'>
                        <div className='hours-title-close-container'>
                            <h2 className='business-hour-title'>Business Hours</h2>
                            <CloseIcon
                                size={30}
                                onClick={onClose}
                                className='close-icon'
                            />
                        </div>
                        {hours?.length > 0 ? (
                            <table className='hours-table'>
                                <thead className='hours-heading'>
                                    <tr>
                                        <th>Day</th>
                                        <th>Hours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {hours.map((hour, index) => (
                                        <tr key={index}>
                                            <td>{hour?.day}</td>
                                            <td>
                                                {hour?.is_open && hour?.intervals?.length > 0
                                                    ? renderIntervals(hour.intervals)
                                                    : <span>Closed</span>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <span className='no-hours'>No business hours available</span>
                        )}
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default BusinessHoursModel;
